import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { Services } from '../components/Services';
import { EstimateBuilder } from '../components/EstimateBuilder';
import { BeforeAfter } from '../components/BeforeAfter';
import { ChecklistMagnet } from '../components/ChecklistMagnet';
import { Reviews } from '../components/Reviews';
import { About } from '../components/About';
import { FinalCta } from '../components/FinalCta';
import { Footer } from '../components/Footer';
import { MobileCallBar } from '../components/MobileCallBar';
import { OfferModal } from '../components/OfferModal';
export function Home() {
  const [selected, setSelected] = useState<string[]>([]);
  const toggleService = (id: string) => setSelected(prev => prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]);
  return <div className="min-h-screen w-full bg-white" data-id="element-325" data-mp="3ovkiy1fxn6bg">
      <Header data-id="element-326" data-mp="30wrnyd4hrrdy" />
      <main data-id="element-327" data-mp="30xb9s4x9izx9">
        <Hero data-id="element-328" data-mp="30x1ime0hempz" />
        <TrustStrip data-id="element-329" data-mp="30vgo2oe633s4" />
        <Services selected={selected} onToggle={toggleService} data-id="element-330" data-mp="30w03nygchg2z" />
        <EstimateBuilder selected={selected} onToggle={toggleService} data-id="element-331" data-mp="2vyq77yujg45n" />
        <BeforeAfter data-id="element-332" data-mp="2qybyeel44q6k" />
        <ChecklistMagnet data-id="element-333" data-mp="2qxkdbxp56auj" />
        <Reviews data-id="element-334" data-mp="2qx0xcmj1xwj5" />
        <About data-id="element-335" data-mp="2r0om78djxurj" />
        <FinalCta data-id="element-336" data-mp="2mx0g6u4kj78e" />
      </main>
      <Footer data-id="element-337" data-mp="2mxs3zirxc0o4" />
      <MobileCallBar data-id="element-338" data-mp="2mw8kzkevvbin" />
      <OfferModal data-id="element-339" data-mp="2mz34n9q2osb0" />
    </div>;
}